import { createSelector } from 'reselect';

export const selectMyRestaurant = createSelector([ (state) => state.restaurant ], (acc) => acc.myRestaurant);
export const selectDetailRestaurant = createSelector([ (state) => state.restaurant ], (acc) => acc.detailRestaurant);
export const selectSelectedFoods = createSelector([ (state) => state.restaurant ], (acc) => acc.selectedFood);

const restaurantSelectors = {
    selectMyRestaurant,
    selectDetailRestaurant,
};

export default restaurantSelectors;
